import { render, staticRenderFns } from "./page3part1.vue?vue&type=template&id=f331c588&scoped=true"
var script = {}
import style0 from "./page3part1.vue?vue&type=style&index=0&id=f331c588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f331c588",
  null
  
)

export default component.exports